import { Box } from "@chakra-ui/react"
import NextLink from 'next/link'

export const Link = ({href, ...props}) => { //deprec prefer ^
  if (!href) return <Box {...{display: 'inline', ...props}} />
  return <NextLink {...{href, passHref: true}}>
    <Box {...{display: 'inline', ...props}} />
  </NextLink>
}

